import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Accordion, Button, Grid, Icon } from 'semantic-ui-react';
import { nextButtonLabel } from './Pane.constants';
import { classNames } from '../../../../../utils/classname';
import StepNumber from '../StepNumber';
import './Pane.css';
var defaultProps = {
  nextButtonText: nextButtonLabel,
  disableNextButton: false,
  isLoading: false,
  active: false,
  onNextClick: null,
  onClick: null,
  iconName: false,
  disabled: false,
  className: ''
};
function Pane(_ref) {
  var children = _ref.children,
    stepNumber = _ref.stepNumber,
    title = _ref.title,
    nextButtonText = _ref.nextButtonText,
    disableNextButton = _ref.disableNextButton,
    isLoading = _ref.isLoading,
    onNextClick = _ref.onNextClick,
    active = _ref.active,
    onClick = _ref.onClick,
    iconName = _ref.iconName,
    disabled = _ref.disabled,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(_defineProperty({
      'accordion-pane-container': true,
      disabled: disabled
    }, className, true))
  }, /*#__PURE__*/React.createElement(Accordion.Title, {
    index: stepNumber,
    active: active,
    onClick: onClick,
    className: "accordion-pane-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-pane-title-left"
  }, /*#__PURE__*/React.createElement(StepNumber, {
    key: stepNumber,
    stepNumber: stepNumber
  }), title), iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: "step-icon"
  })), /*#__PURE__*/React.createElement(Accordion.Content, {
    active: active,
    className: "accordion-pane-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pane-content-container"
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 16
  }, children)), onNextClick && /*#__PURE__*/React.createElement(Grid.Row, {
    className: "pane-button-row"
  }, /*#__PURE__*/React.createElement(Button, {
    loading: isLoading,
    onClick: onNextClick,
    primary: true,
    className: "next-button",
    disabled: !!disableNextButton
  }, nextButtonText))))));
}
Pane.defaultProps = defaultProps;
export default Pane;